export const TAGS = '[TAGS]';

// action types
export const FETCH_TAGS = `${TAGS} FETCH`;
export const DELETE_TAG = `${TAGS} DELETE`;
export const SET_TAGS = `${TAGS} SET`;
export const CREATE_TAG = `${TAGS} CREATE`;
export const UPDATE_TAG = `${TAGS} UPDATE`;
export const SHOW_TAG = `${TAGS} SHOW`;

// Phase 1: these actions now call LifeObject cloud functions.
// The action types and reducer shape are unchanged so no other files need to change.
// Legacy cloud function names (createTag, updateTag, etc.) still exist on the server
// as deprecated wrappers until Phase 9.

export const fetchTags = (query, func) => ({
  type: FETCH_TAGS,
  payload: query,
  // Map legacy function names to new LifeObject equivalents
  function:
    func === 'getTags'
      ? 'getMyLifeObjects'
      : func === 'getTag'
      ? 'getLifeObject'
      : func, // pass through anything else (e.g. tagsByBeaconId) unchanged
});

export const deleteTag = (query) => ({
  type: DELETE_TAG,
  payload: query,
  function: 'deleteLifeObject',
});

export const createTag = ({ query }) => ({
  type: CREATE_TAG,
  payload: query,
  function: 'createLifeObject',
});

export const updateTag = ({ query }) => ({
  type: UPDATE_TAG,
  function: 'updateLifeObject',
  payload: query,
});

export const showTag = ({ query }) => ({
  type: SHOW_TAG,
  index: query.index,
  payload: query.data,
});

export const setTags = ({ tags }) => ({
  type: SET_TAGS,
  payload: tags,
});
